import { Flex } from "antd";
import styled from "styled-components";

export const StyledSelfPlanWrapper = styled(Flex)`
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;

    .ant-collapse + .ant-collapse {
        margin-top: 20px;
    }
`;
